import * as types from './actionTypes';

export function getTeamRequest() {
  return {
    type: types.GET_TEAM_REQUEST,
  };
}

export function getTeamSuccess(payload) {
  return {
    type: types.GET_TEAM_SUCCESS,
    payload,
  };
}

export function getTeamFailure(error) {
  return {
    type: types.GET_TEAM_FAILURE,
    error,
  };
}
